import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import { config } from "../config";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

const isMaintenanceMode = config['maintenanceMode'] === 'true' || config['maintenanceMode'] === true;

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/p/s/:hash",
      name: "portalClientService",
      component: () => import("../views/portal/ServiceForm.vue"),
      meta: { public: true },
    },
    {
      path: "/p/commercial/:hash",
      name: "CommercialOfferValidation",
      component: () => import("../views/portal/DossierCommercialOfferValidation.vue"),
      meta: { public: true },
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import("../views/Maintenance.vue"),
    },
    {
      path: "/",
      component: () => import("../layouts/MainLayout.vue"), // O componente com Menu/Sidebar
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("../views/Home.vue"),
          meta: { title: "Home" },
        },
        {
          path: "/clients",
          name: "ClientList",
          component: () => import("../views/ClientList.vue"),
          meta: {
            permissions: "seeClients",
            title: "Clientes",
          },
        },
        {
          path: "/suppliers",
          name: "SupplierList",
          component: () => import("../views/SupplierList.vue"),
          meta: {
            permissions: "seeSuppliers",
            title: "Fornecedores",
          },
        },
        {
          path: "/equipments",
          name: "Equipments",
          component: () => import("@/views/EquipmentList.vue"),
          meta: {
            permissions: "seeEquipments",
            title: "Equipamentos",
          },
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("../views/Profile.vue"),
          meta: { title: "Perfil" },
        },
        {
          path: "/profile-configurations",
          name: "ProfileConfiguration",
          component: () => import("../views/ProfileConfiguration.vue"),
          meta: { title: "Configurações de Perfil" },
        },
        {
          path: "/support",
          name: "support",
          meta: {
            permissions: "seeSupportSchedule",
            title: "Agenda",
          },
          component: () => import("../views/Support.vue"),
        },
        {
          path: "/employee-info/:id",
          name: "employee-info",
          component: () => import("../views/EmployeeInfo.vue"),
          meta: {
            permissions: "editEmployeeFile",
            title: "Ficha de Colaborador",
          },
        },
        {
          path: "/acls",
          name: "acls",
          component: () => import("../views/Acls.vue"),
          meta: {
            permissions: "seeAcls",
            title: "ACLs",
          },
        },
        {
          path: "/acls-categories",
          name: "acls-categories",
          component: () => import("../views/AclsCategories.vue"),
          meta: {
            permissions: "seeAclsCategories",
            title: "Categorias ACLs",
          },
        },
        {
          path: "/acls-groups",
          name: "acls-groups",
          component: () => import("../views/AclsGroups.vue"),
          meta: {
            permissions: "seeAclsGroups",
            title: "Grupos ACLs",
          },
        },
        {
          path: "/acls-users",
          name: "acls-users",
          component: () => import("../views/AclsUsers.vue"),
          meta: {
            permissions: "viewUserGroupAndAcls",
            title: "Utilizadores ACLs",
          },
        },
        {
          path: "/vehicles",
          name: "vehicles",
          component: () => import("../views/FleetVehicles.vue"),
          meta: {
            permissions: "seeFleetVehicles",
            title: "Veículos",
          },
        },
        {
          path: "/telemetry",
          name: "targaTelematics",
          component: () => import("../views/TargaTelematics.vue"),
          meta: {
            permissions: "seeTargaTelematics",
            title: "Telemetria",
          },
        },
        {
          path: "/telemetry/vehicles/:vin",
          name: "targaTelematicsVehicleDetails",
          component: () => import("../views/TargaTelematicsVehicleDetails.vue"),
          meta: {
            permissions: "seeTargaTelematics",
            title: "Telemetria - Veiculo",
          },
        },
        {
          path: "/vehicle-details/:id",
          name: "vehicle-details",
          component: () => import("../views/FleetVehiclesDetails.vue"),
          meta: {
            permissions: "seeFleetVehicleDetails",
            title: "Detalhe Veículo",
          },
        },
        {
          path: "/serviceOrders/lg",
          name: "serviceOrdersLG",
          component: () => import("../views/ServiceOrdersLG.vue"),
          meta: {
            permissions: "seeServiceOrdersLG",
            title: "Ordens de Serviço LG",
          },
        },
        {
          path: "/serviceOrders/hisense",
          name: "serviceOrdersHisense",
          component: () => import("../views/ServiceOrdersHisense.vue"),
          meta: {
            permissions: "seeServiceOrdersHisense",
            title: "Ordens de Serviço Hisense",
          },
        },
        {
          path: "/serviceOrders/dg",
          name: "serviceOrdersDg",
          component: () => import("../views/ServiceOrdersDg.vue"),
          meta: {
            permissions: "seeServiceOrdersDg",
            title: "Ordens de Serviço D&G",
          },
        },
        {
          path: "/serviceOrders/extranet",
          name: "serviceOrdersExtranet",
          component: () => import("../views/ServiceOrdersExtranet.vue"),
          meta: {
            permissions: "seeExtranetServiceOrders",
            title: "Ordens de Serviço Clientes",
          },
        },
        {
          path: "/stocks",
          name: "stocks",
          component: () => import("../views/StockList.vue"),
          meta: {
            permissions: "seeStock",
            title: "Stock",
          },
        },
        {
          path: "/pats/status",
          name: "patsOrganizer",
          component: () => import("../views/PatOrganizer.vue"),
          meta: {
            permissions: "seePats",
            title: "PATs Organizer",
          },
        },
        {
          path: "/pats/internal-states",
          name: "patsInternalStatesAdmin",
          component: () => import("../views/InternalStatesManager.vue"),
          meta: {
            permissions: "seeAdminInternalStatesPats",
            title: "Estados Internos (Admin)",
          },
        },
        {
          path: "/pats",
          name: "patsByStatus",
          component: () => import("../views/PATsByStatus.vue"),
          meta: {
            permissions: "seePats",
            title: "PATs",
          },
        },
        {
          path: "/pats-internal-states",
          name: "patsByInternalStates",
          component: () => import("../views/PATsByInternalStates.vue"),
          meta: {
            permissions: "seeMenuInternalStatesPats",
            title: "PATs Estados Internos",
          },
        },
        {
          path: "/internal-dossiers",
          name: "internalDossiers",
          component: () => import("../views/internal-dossiers/InternalDossiers.vue"),
          meta: {
            permissions: "seeInternalDossiers",
            title: "Dossiês Internos",
          },
        },
        {
          path: "/orders",
          name: "orders",
          component: () => import("../views/InternalDossierOrderParts.vue"),
          meta: {
            permissions: "seeOrdersParts",
            title: "Encomendas",
          },
        },
        {
          path: "/internal-dossiers/create",
          name: "InternalDossiersFormView",
          component: () => import("../views/internal-dossiers/InternalDossiersFormView.vue"),
          meta: {
            permissions: "seeAddEditInternalDossiers",
            title: "Novo Dossier",
          },
        },
        {
          path: "/internal-dossiers/update/:reference",
          name: "InternalDossiersFormUpdateView",
          component: () => import("../views/internal-dossiers/InternalDossiersFormView.vue"),
          meta: {
            permissions: "seeAddEditInternalDossiers",
            title: "Editar Dossier",
          },
        },
        {
          path: "/purchases",
          name: "Purchases",
          component: () => import("../views/purchases/Purchases.vue"),
          meta: {
            permissions: "seePurchases",
            title: "Compras",
          },
        },
        {
          path: "/purchases/create",
          name: "PurchaseCreate",
          component: () => import("../views/purchases/PurchaseFormView.vue"),
          meta: {
            permissions: ["seePurchases", "seeAddEditPurchases"],
            title: "Nova Compra",
          },
        },
        {
          path: "/purchases/update/:stamp",
          name: "PurchaseEdit",
          component: () => import("../views/purchases/PurchaseFormView.vue"),
          meta: {
            permissions: ["seePurchases", "seeAddEditPurchases"],
            title: "Editar Compra",
          },
        },
        {
          path: "/parts-to-use",
          name: "partsToUse",
          component: () => import("../views/technical-management/PartsToUse.vue"),
          meta: {
            permissions: "seeTechnicalManagementPartsToUse",
            title: "Peças a Utilizar",
          },
        },
        {
          path: "/status-control-pats",
          name: "statusControlPats",
          component: () => import("../views/technical-management/StatusControlPats.vue"),
          meta: {
            permissions: "seeTechnicalManagement",
            title: "Controlo Estados PATs",
          },
        },
        {
          path: "/requested-documentation-control-pats",
          name: "requestedDocumentationControlPats",
          component: () => import("../views/technical-management/RequestedDocumentationControlPats.vue"),
          meta: {
            permissions: "seeTechnicalManagementRequestedDocumentationControlPat",
            title: "Controlo Documentação PATs",
          },
        },
        {
          path: "/commercial-offer-dispatches",
          name: "commercialOfferDispatches",
          component: () => import("../views/technical-management/CommercialOfferDispatches.vue"),
          meta: {
            permissions: "seeTechnicalManagementCommercialOfferDispatches",
            title: "Propostas Enviadas",
          },
        },
        {
          path: "/pats/:id",
          name: "PatDetails",
          component: () => import("../views/PatDetails.vue"),
          meta: {
            requiresAuth: true,
            title: "PAT",
          },
        },
        {
          path: "/spars/brands",
          name: "sparsBrands",
          component: () => import("../views/shop/SparsBrands.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Marcas",
          },
        },
        {
          path: "/spars/suppliers",
          name: "sparsSuppliers",
          component: () => import("../views/shop/SparsSuppliers.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Fornecedores",
          },
        },
        {
          path: "/spars/product/families",
          name: "/sparsProductFamilies",
          component: () => import("../views/shop/SparsProductFamilies.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Famílias Produtos",
          },
        },
        {
          path: "/spars/categories",
          name: "/sparsCategories",
          component: () => import("../views/shop/SparsCategories.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Categorias Loja",
          },
        },
        {
          path: "/spars/equipments",
          name: "/sparsEquipments",
          component: () => import("../views/shop/SparsEquipments.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Equipamentos Loja",
          },
        },
        {
          path: "/spars/products",
          name: "/sparsProducts",
          component: () => import("../views/shop/SparsProducts.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Produtos Loja",
          },
        },
        {
          path: "/spars/administration",
          name: "sparsAdministration",
          component: () => import("../views/shop/SparsAdministration.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Administração",
          },
        },
        {
          path: "/spars/images",
          name: "sparsImages",
          component: () => import("../views/shop/SparsImages.vue"),
          meta: {
            permissions: "seeSpars",
            title: "Imagens",
          },
        },
        {
          path: "/support/map",
          name: "/supportMap",
          component: () => import("../views/SupportMap.vue"),
          meta: {
            permissions: "seeSupportMap",
            title: "Mapa",
          },
        },
        {
          path: "/support/map/:date",
          name: 'support-map-filter',
          component: () => import("../views/SupportMap.vue"),
          meta: { title: "Mapa" },
        },
        {
          path: "/entities",
          name: "/entities",
          component: () => import("../views/Entities.vue"),
          meta: {
            permissions: "seeEntities",
            title: "Entidades",
          },
        },
        // Extranet
        {
          path: "/extranet-users",
          name: "extranetUsers",
          component: () => import("../views/ExtranetUsers.vue"),
          meta: {
            permissions: "seeExtranetUser",
            title: "Utilizadores Extranet",
          },
        },
        {
          path: "/extranet-status",
          name: "extranetStatus",
          component: () => import("../views/ExtranetStatus.vue"),
          meta: {
            permissions: "seeExtranetUser",
            title: "Estados Extranet",
          },
        },
        {
          path: "/employeeFiles",
          name: "employeeFiles",
          component: () => import("../views/EmployeeFiles.vue"),
          meta: {
            permissions: "seeEmployeeFiles",
            title: "Fichas de Colaboradores",
          },
        },
        {
          path: "/googleContacts",
          name: "googleContacts",
          component: () => import("../views/GoogleContactsLogin.vue"),
          meta: {
            permissions: "importContactsToGoogleAccount",
            title: "Conta Google",
          },
        },
        {
          path: "/nacex-accounts",
          name: "nacexAccounts",
          component: () => import("../views/NacexAccounts.vue"),
          meta: {
            permissions: "seeNacexAccounts",
            title: "Contas NACEX",
          },
        },
        {
          path: "/vacations",
          name: "vacations",
          component: () => import("../views/Vacations.vue"),
          meta: {
            requiresAuth: true,
            title: "As minhas Férias",
          },
        },
        {
          path: "/vacationsTeam",
          name: "vacationsTeam",
          component: () => import("../views/VacationsTeam.vue"),
          meta: {
            requiresAuth: true,
            title: "Férias da Equipa",
          },
        },
        {
          path: "/vacationsApprove",
          name: "vacationsApprove",
          component: () => import("../views/VacationsApprove.vue"),
          meta: {
            requiresAuth: true,
            permissions: "approveVacations",
            title: "Aprovar Férias",
          },
        },
        {
          path: "/expenditure/:status?",
          name: "expenditure",
          component: () => import("../views/Expenditure.vue"),
          meta: { title: "Despesas" },
        },
        {
          path: "/expenditure-approve",
          name: "expenditure-approve",
          component: () => import("../views/ExpenditureApprove.vue"),
          meta: { title: "Aprovar Despesas" },
        },
        {
          path: "/miss",
          name: "miss",
          component: () => import("../views/Miss.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeMiss",
            title: "Faltas",
          },
        },
        {
          path: "/miss-approve",
          name: "miss-approve",
          component: () => import("../views/MissApprove.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeMissApprove",
            title: "Aprovar Faltas",
          },
        },
        {
          path: "/helpdesk-tickets",
          name: "helpdesk-tickets",
          component: () => import("../views/helpdesk/HelpdeskTickets.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeHelpdeskMenu",
            title: "Tickets Helpdesk",
          },
        },
        {
          path: "/helpdesk-tickets-detail/:ticketId",
          name: "helpdesk-tickets-detail",
          component: () => import("../views/helpdesk/HelpdeskTicketsDetail.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeHelpdeskMenu",
            title: "Detalhe Ticket",
          },
        },
        {
          path: "/helpdesk-emails",
          name: "helpdesk-emails",
          component: () => import("../views/helpdesk/HelpdeskEmails.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeHelpdeskMenu",
            title: "Emails Helpdesk",
          },
        },
        {
          path: "/helpdesk-blocked-emails",
          name: "helpdesk-blocked-emails",
          component: () => import("../views/helpdesk/HelpdeskBlockedEmails.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeBlockedEmails",
            title: "Emails Bloqueados",
          },
        },
        {
          path: "/helpdesk-blocked-subjects",
          name: "helpdesk-blocked-subjects",
          component: () => import("../views/helpdesk/HelpdeskBlockedSubjects.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeBlockedSubjects",
            title: "Assuntos Bloqueados",
          },
        },
        {
          path: "/ticket-categories",
          name: "ticket-categories",
          component: () => import("../views/helpdesk/HelpdeskTicketsCategories.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeTicketCategories",
            title: "Categorias Tickets",
          },
        },
        {
          path: "/chats",
          name: "Chats",
          component: () => import("../views/ChatsView.vue"),
          meta: {
            permissions: "sendMessageInPatChat",
            title: "Chats",
          },
        },
        {
          path: "/notifications-settings-sms",
          name: "NotificationsSettingsSMS",
          component: () => import("../views/NotificationSettingSMS.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeNotificationsSettings",
            title: "Notificações SMS",
          },
        },
        {
          path: "/notifications-logs",
          name: "NotificationLog",
          component: () => import("../views/NotificationLog.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeNotificationsSettings",
            title: "Histórico Notificações",
          },
        },
        {
          path: "/notifications-settings-email-request-docs",
          name: "NotificationSettingEmailRequestDocs",
          component: () => import("../views/NotificationSettingEmailRequestDocs.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeNotificationsSettings",
            title: "Email - Solicitação Docs",
          },
        },
        {
          path: "/notifications-settings-sms-request-docs",
          name: "NotificationSettingSMSRequestDocs",
          component: () => import("../views/NotificationSettingSMSRequestDocs.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeNotificationsSettings",
            title: "SMS - Solicitação Docs",
          },
        },
        {
          path: "/dashboards",
          alias: "/reports",
          name: "dashboards",
          component: () => import("../views/Dashboard.vue"),
          meta: {
            permissions: "seeDashboardsMenu",
            anyPermissions: ["seeOperationsDashboard", "seeFinanceDashboard"],
            title: "Visão 360°",
          },
        },
        {
          path: "/integration-lg/config-codes",
          name: "IntegrationLgConfigCodes",
          component: () => import("../views/IntegrationLgConfigCodesForm.vue"),
          meta: {
            permissions: "seeIntegrationLgSettings",
            title: "Integração LG",
          },
        },
        {
          path: "/transport-documents/locations",
          name: "TransportDocumentsLocations",
          component: () => import("../views/transport-documents/TransportDocumentLocations.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeTransportDocumentsLocations",
            title: "Guias de Transporte",
          },
        },
        {
          path: "/transport-documents/accessories",
          name: "ReceptionAccessories",
          component: () => import("../views/transport-documents/ReceptionAccessories.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeTransportDocumentsLocations",
            title: "Acessórios Recepção",
          },
        },
        {
          path: "/shipments/nacex",
          name: "ShipmentsNacex",
          component: () => import("../views/ShipmentsNacex.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeShipmentTracking",
            title: "Expedições NACEX",
          }
        },
        {
          path: "/logs",
          name: "Logs",
          component: () => import("../views/LogsView.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeLogs",
            title: "Logs",
          }
        },
        {
          path: "/audits",
          name: "Audits",
          component: () => import("../views/AuditsView.vue"),
          meta: {
            requiresAuth: true,
            permissions: "seeAudits",
            title: "Auditorias",
          }
        }
      ],
    },
  ],
});

const CHUNK_ERROR_RELOAD_KEY = "chunk_error_reload";

const isChunkLoadError = (error) => {
  const message = error && error.message ? error.message : "";

  return (
    error &&
    (error.name === "ChunkLoadError" || /loading.*chunk.*failed/i.test(message))
  );
};

router.onError((error) => {
  if (
    isChunkLoadError(error) &&
    !sessionStorage.getItem(CHUNK_ERROR_RELOAD_KEY)
  ) {
    sessionStorage.setItem(CHUNK_ERROR_RELOAD_KEY, "1");
    window.location.reload();
  }
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const loggedIn = localStorage.getItem("user");

  const isPublicRoute = to.matched.some(record => record.meta.public);
  const authRequired = !publicPages.includes(to.path) && !isPublicRoute;

  if (isMaintenanceMode) {
    if (to.path !== '/maintenance') {
      return next('/maintenance');
    }

    return next();
  }

  if (to.path === '/maintenance') {
    return next('/');
  }

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && (!loggedIn || loggedIn == null)) {
    next("/login");
  } else {
    var userPermissions = [];
    if (loggedIn != undefined && JSON.parse(loggedIn).moreInfo != undefined) {
      userPermissions = loggedIn
        ? JSON.parse(window.atob(JSON.parse(loggedIn).moreInfo))
        : [];
      if (to.meta.permissions) {
        const requiredPermissions = Array.isArray(to.meta.permissions)
          ? to.meta.permissions
          : [to.meta.permissions];
        let isAllowed = requiredPermissions.every((permission) =>
          userPermissions.includes(permission)
        );

        if (!isAllowed) {
          return next("/");
        }
      }
    }
    if (to.meta.anyPermissions && !to.meta.anyPermissions.some((permission) => userPermissions.includes(permission))) {
      return next("/");
    }
    next();
  }
});

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_ERROR_RELOAD_KEY);
});
